const ro = {
    Menu: 'Meniu',
    Nomenclatures: 'Nomenclatoare',
    Account: 'Cont',
    Dashboard: 'Administrare',
    Users: 'Utilizatori',
    Offers: 'Oferte',
    Tasks: 'Sarcini',
    Objectives: 'Obiective',
    Clients: 'Clienți',
    Vehicles: 'Vehicule',
    'Work points': 'Puncte de lucru',
    'Client source': 'Sursă client',
    Profile: 'Profil',
    Logout: 'Deloghează-te',
    'Technical support': 'Suport tehnic',
    Councilors: 'Consilieri',
};

export default { ro };
